<template>
  <div class="home-container" ref="container" @wheel="handleWheel">
    <ul class="home-banner" :style="{
      marginTop: index * -clientHeight + 'px'
    }" @transitionend="handleTransitionend">
      <li v-for="item in banners" :key="item.id">
        <CarouselItem :carousel="item"></CarouselItem>
      </li>
    </ul>
    <div v-show="index > 0" class="arrow-up" @click="handleUp">
      <Icon type="shangjiantou"></Icon>
    </div>
    <div v-show="index < banners.length - 1" class="arrow-down" @click="handleDown">
      <Icon type="xiajiantou"></Icon>
    </div>
    <div class="circle">
      <ul>
        <li v-for="(item, i) in banners" :key="item.id" :class="{ active: i === index }" @click="handleCirClick(i)"></li>
      </ul>
    </div>
  </div>
</template>
  
<script>
// import { getbanner } from '../../api/banner';
import CarouselItem from './CarouselItem.vue';
import Icon from '../../components/Icon';
export default {
  components: {
    CarouselItem,
    Icon
  },
  data() {
    return {
      index: 0,
      clientHeight: 0,
      banners: [
        {
          id: "1",
          midImg: "http://mdrs.yuanjin.tech/img/20201031141507.jpg",
          bigImg: "http://mdrs.yuanjin.tech/img/20201031141350.jpg",
          title: "凛冬将至",
          description: "人唯有恐惧的时候方能勇敢",
        },
        {
          id: "2",
          midImg: "http://mdrs.yuanjin.tech/img/20201031205550.jpg",
          bigImg: "http://mdrs.yuanjin.tech/img/20201031205551.jpg",
          title: "血火同源",
          description: "如果我回头，一切都完了",
        },
        {
          id: "3",
          midImg: "http://mdrs.yuanjin.tech/img/20201031204401.jpg",
          bigImg: "http://mdrs.yuanjin.tech/img/20201031204403.jpg",
          title: "听我怒吼",
          description: "兰尼斯特有债必偿",
        },
      ],
      sliding: false,
      isLoading: true
    }
  },
  // created() {
  //   getbanner().then(r => {
  //     this.banners = r.data.data;
  //     this.isLoading = false
  //   })
  // },
  mounted() {
    this.clientHeight = this.$refs.container.clientHeight;
    window.addEventListener('resize', this.handleResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleUp() {
      if (this.index == 0) {
        return
      }
      this.index--;
    },
    handleDown() {
      if (this.index >= this.banners.length - 1) {
        return
      }
      this.index++
    },
    handleCirClick(i) {
      this.index = i
    },
    handleWheel(e) {
      if (this.sliding) {
        return
      }
      if (e.deltaY >= 100 && this.index < this.banners.length - 1) {
        this.sliding = true
        this.index++;
      }
      if (e.deltaY <= -100 && this.index > 0) {
        this.sliding = true
        this.index--
      }
    },
    handleTransitionend() {
      this.sliding = false
    },
    handleResize() {
      this.clientHeight = this.$refs.container.clientHeight
    }
  }
}
</script>
  
<style scoped lang="less">
.home-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  //测试用
  // width: 500px;
  // height: 400px;
  // background: #333;
  // position: relative;
  // overflow: visible;
  // margin: 200px auto;
  // border: 3px solid red;
  // z-index:999;

  .home-banner {
    width: 100%;
    height: 100%;

  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    transition: .4s;

    li {
      width: 100%;
      height: 100%;
    }
  }


}

@keyframes jump-up {
  0% {
    transform: translateY(-10px);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(-10px);
  }
}

@keyframes jump-down {
  0% {
    transform: translateY(10px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(10px);
  }
}

.arrow-up {
  position: absolute;
  top: 20px;
  left: 50%;
  animation: jump-up 2s infinite;

  .icon-container {
    color: #fff;
  }
}

.arrow-down {
  position: absolute;
  bottom: 20px;
  left: 50%;
  animation: jump-down 2s infinite;

  .icon-container {
    color: #fff;
  }
}

.arrow-up,
.arrow-down {
  cursor: pointer;
}

.circle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform: translateY(-50%);
  left: auto;
  right: 20px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #000;
      margin-bottom: 10px;
      box-sizing: border-box;
      border: 1px solid #fff;
      cursor: pointer;
    }

    .active {
      background: #fff;
    }
  }
}
</style>